import { render } from "./SelectorHtmlBased.vue?vue&type=template&id=c17dbc98&scoped=true&ts=true"
import script from "./SelectorHtmlBased.vue?vue&type=script&lang=ts"
export * from "./SelectorHtmlBased.vue?vue&type=script&lang=ts"

import "./SelectorHtmlBased.vue?vue&type=style&index=0&id=c17dbc98&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17dbc98"]])

export default __exports__